import numberUtils from '@/utils/number';

import type { CompositedSignalIssue } from '../model';

export const getChangePercentage = (
  prev: number,
  current: number,
): number | null => {
  if (prev === 0 && current === 0) return 0;
  if (prev === 0) return null; // null 인 경우 new
  if (current === 0) return -100; // 0 인 경우 사라진 것이므로 -100%
  return numberUtils.getSharePercentage(current - prev, prev, 1);
};

export const isNewSignalIssue = (issue: {
  comparisonPeriodCount: number;
  selectedPeriodCount: number;
}) =>
  issue.selectedPeriodCount > 0 && issue.comparisonPeriodCount === 0;

// feedback count 정렬 (높은 count가 먼저)
export const feedbackCountSort = (
  a: Pick<CompositedSignalIssue, 'selectedPeriodCount'>,
  b: Pick<CompositedSignalIssue, 'selectedPeriodCount'>,
) => {
  return b.selectedPeriodCount - a.selectedPeriodCount;
};

export const changeSort = (
  a: {
    comparisonPeriodCount: number;
    selectedPeriodCount: number;
  },
  b: {
    comparisonPeriodCount: number;
    selectedPeriodCount: number;
  },
) => {
  const changeA = getChangePercentage(
    a.comparisonPeriodCount,
    a.selectedPeriodCount,
  );
  const changeB = getChangePercentage(
    b.comparisonPeriodCount,
    b.selectedPeriodCount,
  );

  // null (새로운 항목)은 높은 우선순위로 처리
  if (changeA === null && changeB === null) {
    // 둘 다 null이면 selectedPeriodCount로 정렬
  } else if (changeA === null)
    return -1; // issueA가 새 항목이면 먼저
  else if (changeB === null)
    return 1; // issueB가 새 항목이면 먼저
  else {
    // 둘 다 null이 아니면 변화량의 절대값으로 정렬 (큰 변화가 먼저)
    const absChangeA = Math.abs(changeA);
    const absChangeB = Math.abs(changeB);
    const changeDiff = absChangeB - absChangeA;
    if (changeDiff !== 0) return changeDiff;
  }
  return 0;
};
